import { Component, OnDestroy } from '@angular/core';
import { StorageService } from '../../services';

/**
 * Shell that operates with a club-overview
 */
@Component({
  selector: 'app-club-overview-shell',
  template: `
            <router-outlet></router-outlet>
            `
})
export class ClubShellComponent implements OnDestroy {
  constructor(private storage: StorageService) { }

  public ngOnDestroy(): void {
    this.storage.clearSelectedClub();
    document.querySelector('body').style.cssText = '--header-color: null';
  }
}
